module.exports = [{
      plugin: require('/Users/stoyan/Projects/Calf-Hey/calf-hey/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
